import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import './Home.css';

function Home({ user }) {
  const handleDownload = (e) => {
    e.preventDefault();
    if (!user) {
      // Перекидываем на авторизацию через Steam
      window.location.href = 'https://optimizerust.ru/api/auth/steam';
      return;
    }
    if (user.purchaseStatus !== 'active') {
      alert('Для скачивания необходимо приобрести тарифный план. Обратитесь к администратору.');
      return;
    }
    // Если все ок, разрешаем скачивание
    window.location.href = '/api/downloads/file';
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "OptimizeRust",
    "applicationCategory": "GameApplication",
    "operatingSystem": "Rust Server",
    "offers": {
      "@type": "Offer",
      "price": "500",
      "priceCurrency": "RUB"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "50"
    },
    "description": "Продвинутый плагин оптимизации сервера Rust с системой повышения FPS. Увеличьте производительность на 20-60 FPS.",
    "author": {
      "@type": "Person",
      "name": "Frequest"
    }
  };

  return (
    <div className="home">
      <SEO 
        title="OptimizeRust - Оптимизация сервера Rust | Плагин для повышения FPS"
        description="Продвинутый плагин оптимизации сервера Rust с системой повышения FPS. Увеличьте производительность вашего сервера на 20-60 FPS. Скачать плагин для Rust oxide/umod."
        keywords="rust, rust server, rust plugin, optimize rust, fps boost, rust optimization, oxide plugin, umod plugin, rust server optimization, повышение fps rust"
      />
      <StructuredData type="software" data={structuredData} />
      <section className="hero">
        <div className="hero-background">
          <img 
            src="https://files.facepunch.com/paddy/20211005/missions_hero.jpg" 
            alt="Rust Missions" 
            className="hero-bg-image"
          />
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">OptimizeRust</h1>
              <p className="hero-subtitle">
                Продвинутый плагин оптимизации сервера Rust с системой повышения FPS
              </p>
          <div className="hero-buttons">
            <Link to="/pricing" className="btn btn-primary">Выбрать план</Link>
            <button onClick={handleDownload} className="btn">
              {user?.purchaseStatus === 'active' ? 'Скачать' : user ? 'Требуется покупка' : 'Скачать'}
            </button>
          </div>
          {user && user.purchaseStatus !== 'active' && (
            <div className="purchase-notice">
              <p>Для скачивания плагина необходимо приобрести тарифный план. Обратитесь к администратору.</p>
            </div>
          )}
            </div>
            <div className="hero-image">
              <img 
                src="https://files.facepunch.com/MartynChapman/2025/November/rust_nov2025update_horsemedsyringes_01.jpg" 
                alt="Rust Horse Update" 
                className="hero-main-image"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="features section">
        <div className="container">
          <h2 className="section-title">Возможности</h2>
          <div className="grid">
            <div className="card">
              <h3 className="card-title">Уровень 1 (Базовый)</h3>
              <p className="card-text">
                Примерно +20 FPS. Оптимизация I/O операций, запланированная сборка мусора, 
                настройка интервала обновления сущностей.
              </p>
            </div>
            <div className="card">
              <h3 className="card-title">Уровень 2 (Продвинутый)</h3>
              <p className="card-text">
                Примерно +40 FPS. Все оптимизации уровня 1, агрессивная сборка мусора, 
                сниженная частота обновления сущностей, оптимизация сетевых пакетов.
              </p>
            </div>
            <div className="card">
              <h3 className="card-title">Уровень 3 (Максимальный)</h3>
              <p className="card-text">
                Примерно +60 FPS. Все оптимизации уровня 2, максимальная сборка мусора, 
                оптимизация конвейера рендеринга, настройка частоты обновления физики.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="how-it-works section">
        <div className="container">
          <h2 className="section-title">Как это работает</h2>
          <div className="grid">
            <div className="card">
              <div className="card-image-wrapper">
                <img 
                  src="https://files.facepunch.com/paddy/20211005/missions_hero.jpg" 
                  alt="Управление памятью" 
                  className="card-image"
                />
              </div>
              <h3 className="card-title">Управление памятью</h3>
              <p className="card-text">
                Интеллектуальное планирование сборки мусора для снижения фрагментации 
                памяти и повышения эффективности выделения.
              </p>
            </div>
            <div className="card">
              <div className="card-image-wrapper">
                <img 
                  src="https://files.facepunch.com/paddy/20241003/rust_dpv_03.jpg" 
                  alt="Оптимизация обновлений" 
                  className="card-image"
                />
              </div>
              <h3 className="card-title">Оптимизация обновлений</h3>
              <p className="card-text">
                Снижение ненужных циклов обновления сущностей путем реализации 
                умных интервалов обновления.
              </p>
            </div>
            <div className="card">
              <div className="card-image-wrapper">
                <img 
                  src="https://files.facepunch.com/MartynChapman/2025/November/rust_nov2025update_horsemedsyringes_01.jpg" 
                  alt="Обработка сетевых пакетов" 
                  className="card-image"
                />
              </div>
              <h3 className="card-title">Обработка сетевых пакетов</h3>
              <p className="card-text">
                Оптимизация обработки сетевых пакетов для снижения задержки и 
                повышения отзывчивости сервера.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;

